var map = {
	"./hk/introduction/score-demo.png": 4121,
	"./hk/introduction/standard.png": 8892,
	"./hk/logo/logo.png": 3180,
	"./kg/introduction/score-demo.png": 88,
	"./kg/introduction/standard.png": 3532,
	"./kg/logo/logo.png": 1409,
	"./my/introduction/score-demo.png": 118,
	"./my/introduction/standard.png": 2692,
	"./my/logo/logo.png": 6853,
	"./pl/introduction/score-demo.png": 3322,
	"./pl/introduction/standard.png": 1571,
	"./pl/logo/logo.png": 8115,
	"./tw/introduction/score-demo.png": 7320,
	"./tw/introduction/standard.png": 9314,
	"./tw/logo/logo.png": 4044,
	"./us/introduction/score-demo.png": 879,
	"./us/introduction/standard.png": 5761,
	"./us/logo/logo.png": 7899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3796;